<template>
  <div class="empty-state">
    <div class="empty-image">
      <img :src="imageSrc" alt="暂无数据" />
    </div>
    <div class="empty-text">
      <p>{{ description }}</p>
    </div>
    <div class="empty-action" v-if="$slots.default">
      <slot></slot>
    </div>
  </div>
</template>

<script>
// 直接导入图片资源，避免 require 在某些构建环境下的问题
import defaultImage from '@/assets/icon/defaultPageImage.png'

export default {
  name: 'EmptyState',
  props: {
    description: {
      type: String,
      default: '暂无数据'
    },
    image: {
      type: String,
      default: ''
    }
  },
  computed: {
    imageSrc() {
      if (this.image) {
        return this.image
      }
      return defaultImage
    }
  }
}
</script>

<style scoped>
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 0;
  width: 100%;
  height: 100%;
  min-height: 300px;
}

.empty-image {
  margin-bottom: 20px;
}

.empty-image img {
  width: 200px;
  height: auto;
  opacity: 0.8;
}

.empty-text {
  color: #888;
  font-size: 14px;
  text-align: center;
}

.empty-action {
  margin-top: 20px;
}
</style>
